import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ApiService, ObservalbeStateService, UtilityService } from '../../service';

@Component({
  selector: 'app-main-menu',
  templateUrl: './main-menu.component.html',
  styleUrls: ['./main-menu.component.scss']
})
export class MainMenuComponent implements OnInit {
  menuData: any;
  profile: any;
  getFromPage:any;
  pwdFlag: string;
  userInfo: any;
  constructor(public router: Router, public api: ApiService, public observable: ObservalbeStateService,
    public utility: UtilityService, public http: HttpClient) { }

  ngOnInit(): void {
    this.userInfo = JSON.parse(localStorage.getItem('vprpinfo'));
    this.getFromPage = localStorage.getItem(`fromPage`);
    this.pwdFlag = localStorage.getItem(`pwdresetflags`);
    const prof = localStorage.getItem(`vprpinfo`);
    this.profile = JSON.parse(prof);
    this.getMenuList();
  }

  getMenuList(){
    const reqHeader = {
      "_user_code": this.userInfo.loginId,
      "_user_token": "",
      "_url": '/getFetMenuList',
      "_succ_msg": ""
    }
    this.http.post(`${environment.endpoint}/${'iudUsertoken'}`, JSON.stringify(reqHeader), { headers: this.iudgetHeaders('/iudUsertoken') }).subscribe(async (res: any) => {
      if (res) {
      if(this.profile?.userRoles?.length > 0) {
        this.api.get(`/getFetMenuList?roleCode=${this.profile.userRoles[0].applicationRole.roleName}@${res.myArrayList[0].map._user_token}`).subscribe((res: any) => {
          if(res){
            this.menuData = res[0].filter(item => item.menu_type_code == 'L');
          }
        });
      }
    }
  });
  }

  getMenuCode(_data:any){
    // console.log(`_data`, _data);
    this.observable.MenuCode(_data);
    this.router.navigateByUrl(_data.url_action_method);
  }

  iudgetHeaders(url) {
    let headerValue = {};
    const token = localStorage.getItem(`token`);
      headerValue =  {
        'Content-Type':  'application/json',
        'Content-Security-Policy': "default-src 'self'; style-src 'self' fonts.googleapis.com; font-src fonts.gstatic.com",
        'X-Tenant-Identifier': 'dynamic_lokos',
        'Authorization': token ? 'Bearer ' + token: '',
        'Cache-Control':  'no-cache, no-store, must-revalidate, post- check=0, pre-check=0',
        'Pragma': 'no-cache',
        'Expires': '0',
        // "Referrer-Policy": "no-referrer, strict-origin-when-cross-origin",
        // "Strict-Transport-Security": "max-age=63072000; includeSubDomains",
        // "X-Content-Type-Options": "nosniff",
        "X-Frame-Options": "DENY",
        // "X-XSS-Protection": "1; mode=block",
        '_url': url,
        '_user_token': '',
        'userCode': '',
        'roleCode': '',
        'blockCode': '',
    }
      return new HttpHeaders(headerValue);
    }

}
